export const sortTerms = (a, b) => {
	const nameA = a.name.toUpperCase(); // ignore upper and lowercase
	const nameB = b.name.toUpperCase(); // ignore upper and lowercase
	if (nameA < nameB) return -1;
	if (nameA > nameB) return 1;
	return 0; // names must be equal
};
